import { de } from "../../../../date-fns/locale/de.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    de
  }
};